<app-open-orders-filters (searchSubmitted)="getFilters($event)" [shippingAddressGroup]="shippingAddressGroup">
</app-open-orders-filters>
<div class="mb-4 mt-1 tableContainer customScrollbar">
  <table class="table">
    <thead>
      @if (results && results.length) {
        <tr class="financial-item">
          <td style="max-width: 30px">
          </td>
          <td>
            {{'DESCRIPTION'|translate}}
          </td>
          @if (applicationService.getSelectCompanyGroupCode() === 'WG') {
            <td>
              {{'BRAND'|translate}}
            </td>
          }
          <td class="text-center">
            {{'QUANTITY'|translate}}
          </td>
          <td class="text-center">
            {{'DELIVERY'|translate}}
          </td>
          <td>
            {{'ORDERNUMBER'|translate}}
          </td>
          @if (applicationService.getSelectCompanyGroupCode() !== 'LAP' && applicationService.getSelectCompanyGroupCode() !== 'GHO') {
            <td>
              {{'REFERENCE'|translate}}
            </td>
          }
          @if (applicationService.getSelectCompanyGroupCode() === 'WG') {
            <td>
              {{'PREORDER'|translate}}
            </td>
          }
          <td>
            {{'AMOUNT'|translate}}
          </td>
          @if (applicationService.getSelectCompanyGroupCode() !== 'WG') {
            <td>
              {{'REMARKS'|translate}}
            </td>
          }
          @if (applicationService.getSelectCompanyGroupCode() !== 'WG') {
            <td>
              {{'SOLD'|translate}}
            </td>
          }
          <td>
            {{'DELIVERY_WEEK'|translate}}
          </td>
          <td colspan="3"></td>
        </tr>
      }
      @if (loaded && results && !results.length && loaded) {
        <tr>
          <td class="border-0">
            <app-no-results></app-no-results>
          </td>
        </tr>
      }
    </thead>
    <tbody>
      @for (item of results; track item; let rowIndex = $index) {
        @if (rowIndex < showIndex) {
          <app-open-order-line class="w-100 d-block d-table-row small financial-item"
            [shippingAddressGroup]="shippingAddressGroup"
            [attr.data-index]="(rowIndex + 1 + ((pageData.page - 1) * 50))" [orderLine]="item" [image]="item.image"
          ></app-open-order-line>
        }
      }
    </tbody>
  </table>
  @if ((keyWord && results && results.length > showIndex) || page < totalPages) {
    <button class="btn btn-dark btn-block" (click)="showMore()">{{"SHOW_MORE"|translate}}</button>
  }
</div>

@if (results && results.length && applicationService.getSelectCompanyGroupCode() !== 'WG') {
  <div class="row">
    <div class="col-md-10">
      <!-- Number of results -->
      <div class="numResults">
        @if (pageData.numResults['openorders']) {
          <app-num-results-open-orders
          [numResults]="pageData.numResults['openorders']"></app-num-results-open-orders>
        }
      </div>
    </div>
  </div>
}
@if (initial) {
  <ngx-skeleton-loader count="20" appearance="line" [theme]="{height: '80px' }">
  </ngx-skeleton-loader>
}

<!-- Paginator -->
@if (results && results.length) {
  <app-financial-paginator [(pageData)]="pageData" (navigation)="navigationChanged($event)">
    <app-open-orders-options class="w-100 d-inline-block" [(pageData)]="pageData" [filters]="openOrdersFilters" [items]="results">
    </app-open-orders-options>
  </app-financial-paginator>
}
